// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__28OFW","subcontainer":"styles_subcontainer__2un2G"};